<input
    type="button"
    (click)="onClick()"
    value="Click Me For Selected Row Count"
  />